import React from "react"
import ReactDOM from "react-dom/client"
import "./styles/themes.css"
import "./styles/App.css"
import "./styles/header.css"
import "./styles/reg.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import "./i18n"
import ErrorBoundary from "./components/ErrorBoundary"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
/*
spy((ev) => {
    if (ev.type.includes('action')) { console.log(ev) }
})*/
